export const style = variant => ({
  '&.MuiDataGrid-root': {
    fontFamily: 'lucidaSansUnicode, lucidaGrande, Sans-Serif',
    fontSize: '12px',

    // Override column header row height
    '& .MuiDataGrid-columnHeaderRow': {
      height: 'auto !important',
      minHeight: '48px !important',
      maxHeight: 'auto !important',
    },

    // Override data row height with border bottom.
    //
    // Scoped to `.MuiDataGrid-row` deliberately. MUI puts `row--borderBottom` on the
    // COLUMN HEADER row as well as on data rows (see useGridColumnHeaders), and the
    // header row carries its height as an inline style. An unscoped
    // `height: auto !important` beat that inline height and forced the header row to
    // this 40px minimum on top of the 48px `columnHeaderRow` minimum above — which is
    // what produced the empty band between the header and the first row.
    // Only data rows have both classes, so this targets them alone.
    '& .MuiDataGrid-row.MuiDataGrid-row--borderBottom': {
      height: 'auto !important',
      minHeight: '40px !important',
      maxHeight: 'auto !important',
    },

    '& .MuiDataGrid-pinnedColumnHeaders': {
      minHeight: 'unset !important',
      maxHeight: 'unset !important',
      height: '100%',
      '& > div:first-of-type': {
        height: '100% !important',
      },
    },
    '& .MuiDataGrid-columnHeaders': {
      minHeight: 'unset !important',
      maxHeight: 'unset !important',
    },
    '& .MuiDataGrid-toolbarContainer': {
      padding: '8px',
      paddingBottom: '14px',
      marginBottom: '8px',
      rowGap: '8px',
      columnGap: '8px',
      alignItems: 'flex-start',
      borderTop: 'none !important',
      borderBottom: 'none !important',
      boxShadow: 'none !important',
    },
    '& .MuiDataGrid-main': {
      marginTop: '10px',
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: variant === 'secondary' ? '#4287f5' : 'black',
      color: 'white',
      height: 'auto !important',
      '.MuiDataGrid-sortIcon': {
        fill: 'white',
      },
      // restore sort icon instead of white dot
      '& .MuiDataGrid-sortButton': {
        backgroundColor: 'transparent !important',
      },
      '&:hover': {
        '& .MuiDataGrid-columnHeaderTitle': {
          whiteSpace: 'nowrap',
        },
      },
      '& .MuiButtonBase-root.MuiCheckbox-root': {
        padding: 0.3,
        '& .MuiSvgIcon-root': {
          width: '16px',
          height: '16px',
          fill: 'white',
        },
      },
    },
    //Based on https://github.com/mui/mui-x/issues/898
    '& .MuiDataGrid-columnHeaderTitle': {
      whiteSpace: 'break-spaces',
      lineHeight: 1.3,
      padding: '8px 0',
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer': {
      pl: 1,
    },
    '& .MuiDataGrid-menuIconButton': {
      color: 'white',
    },
    '& .MuiDataGrid-columnHeaderCheckbox .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root': {
      color: 'white',
    },
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
      '&.highlight-row': {
        backgroundColor: 'rgb(166, 247, 196)',
      },
    },
    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
      display: 'flex',
      alignItems: 'center',
      py: 0.5,
    },
    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
      display: 'flex',
      alignItems: 'center',
      py: 1,
    },
    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
      display: 'flex',
      alignItems: 'center',
      py: 1.5,
    },
    // No vertical margins on the pagination labels.
    //
    // These previously carried `marginTop/marginBottom: 1em`. MUI's pagination
    // toolbar and the grid's footer container are both `minHeight: 52`, so ~32px of
    // margin around ~20px of text overflowed the bar and the footer rendered its own
    // vertical scrollbar. The toolbar is already `display: flex; align-items: center`,
    // so the labels sit centred without any margin; spacing between items comes from
    // the toolbar's row/column gap below.
    '& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel': {
      marginTop: 0,
      marginBottom: 0,
    },
    '& .MuiTablePagination-toolbar': {
      flexWrap: 'wrap',
      rowGap: '8px',
      columnGap: '8px',
      justifyContent: 'flex-end',
      // Wrapping is kept for narrow viewports, where the toolbar legitimately needs
      // more than one line — but then it has to be allowed to grow past 52px instead
      // of overflowing. `height: auto` lets the footer expand; the container's own
      // minHeight still holds the single-line case at 52px.
      height: 'auto',
    },
    '& .MuiDataGrid-toolbarContainer, & .MuiTablePagination-toolbar': {
      width: '100%',
    },
    '@media (max-width: 1280px)': {
      '& .MuiDataGrid-toolbarContainer': {
        padding: '8px 4px',
      },
      '& .MuiTablePagination-toolbar': {
        justifyContent: 'flex-start',
      },
    },
    //Check box selection style
    '& .MuiDataGrid-cellCheckbox': {
      '& .MuiButtonBase-root': {
        padding: 0.3,
        '& .MuiSvgIcon-root': {
          width: '16px',
          height: '16px',
        },
      },
    },
    '& .cell-in-error': {
      borderColor: 'red',
    },
    '& .MuiSelect-select': {
      //padding: '4px',
    },
    '& .MuiDataGrid-virtualScrollerRenderZone': {
      paddingBottom: '16px',
    },
  },
  '--DataGrid-overlayHeight': '150px',
});
